import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "container my-lg-5 my-4"
};
var _hoisted_2 = {
  key: 0,
  "class": "text-center"
};
var _hoisted_3 = {
  "class": "row g-4"
};
var _hoisted_4 = {
  "class": "col-lg-4 col-md-6"
};
var _hoisted_5 = {
  "class": "row g-4 mt-2"
};
var _hoisted_6 = {
  "class": "col-lg-4 col-md-6 collapse",
  id: "expand-ideas"
};
var _hoisted_7 = {
  "class": "text-center mt-5 py-3"
};
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_spinner = _resolveComponent("spinner");
  var _component_directory_demo_idea = _resolveComponent("directory-demo-idea");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.inProgress ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_spinner)])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    "class": "text-center mb-5"
  }, [_createElementVNode("h3", {
    "class": "sh-text-dark-blue"
  }, [_createTextVNode("Don’t know what to search?"), _createElementVNode("br"), _createTextVNode(" Explore some ideas!")])], -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.defaultIdeas, function (idea) {
    return _openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_directory_demo_idea, {
      idea: idea
    }, null, 8, ["idea"])]);
  }), 256))]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.extraIdeas, function (idea) {
    return _openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_directory_demo_idea, {
      idea: idea
    }, null, 8, ["idea"])]);
  }), 256))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.expanded = !$data.expanded;
    }),
    href: "#",
    "class": "btn btn-outline-primary px-5",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#expand-ideas",
    "aria-expanded": "false",
    "aria-controls": "expand-ideas"
  }, [_cache[1] || (_cache[1] = _createElementVNode("img", {
    src: "/img/v5/ico-dir-idea.svg",
    "class": "mt-n1"
  }, null, -1)), _cache[2] || (_cache[2] = _createTextVNode()), $data.expanded ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Show less ideas")) : (_openBlock(), _createElementBlock("span", _hoisted_9, "Give me another idea"))])])], 64))]);
}